'use client';

import { useIntl } from 'react-intl';
import Tags from '@alltrails/seo/components/Tags';
import type { LocationSeoLinks as LocationSeoLinksType } from '@alltrails/trails';
import PageSection from '../layouts/PageSection';
import styles from './LocationSeoLinks.module.scss';

type LocationSeoLinksProps = {
  locationSeoLinks: LocationSeoLinksType;
  trailName: string;
  isBot: boolean;
};

const LocationSeoLinks = ({ locationSeoLinks, trailName, isBot }: LocationSeoLinksProps) => {
  const intl = useIntl();

  if (!locationSeoLinks.tags.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <PageSection hasDividerTop={false}>
        <Tags
          heading={intl.formatMessage({ defaultMessage: 'Explore near {trailName}' }, { trailName })}
          slug={locationSeoLinks.locationSlug}
          tags={locationSeoLinks.tags}
          pointsOfInterest={locationSeoLinks.pointsOfInterest}
          isBot={isBot}
          className={styles.tags}
          getActivityLabel={label => label}
        />
      </PageSection>
    </div>
  );
};

export default LocationSeoLinks;
